// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"0582ef61","460":"0582ef61","476":"0582ef61","620":"e1a8ccaa"}[chunkId] + ".chunk.css";
};